import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/layout/SmoothScroll";
import Layout from "@/components/layout/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import ServicePage from "@/pages/ServicePage";
import FractionalCIO from "@/pages/FractionalCIO";
import ExecutiveAdvisory from "@/pages/ExecutiveAdvisory";
import DigitalTransformation from "@/pages/DigitalTransformation";
import AIStrategy from "@/pages/AIStrategy";
import ERPStrategy from "@/pages/ERPStrategy";
import TechnologyStrategy from "@/pages/TechnologyStrategy";
import Industries from "@/pages/Industries";
import CaseStudies from "@/pages/CaseStudies";
import Insights from "@/pages/Insights";
import InsightDetail from "@/pages/InsightDetail";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminProtected from "@/pages/admin/AdminProtected";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminBlogEditor from "@/pages/admin/AdminBlogEditor";
import AdminMedia from "@/pages/admin/AdminMedia";
import AdminSecurity from "@/pages/admin/AdminSecurity";
import Journal from "@/pages/Journal";
import JournalDetail from "@/pages/JournalDetail";
import SuccessStories from "@/pages/SuccessStories";
import SuccessStoryDetail from "@/pages/SuccessStoryDetail";
import { Navigate } from "react-router-dom";
import Videos from "@/pages/Videos";
import Resources from "@/pages/Resources";
import BookSession from "@/pages/BookSession";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <SmoothScroll>
            <Routes>
              <Route element={<Layout />}>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/services/fractional-cio" element={<FractionalCIO />} />
                <Route path="/services/executive-advisory" element={<ExecutiveAdvisory />} />
                <Route path="/services/digital-transformation" element={<DigitalTransformation />} />
                <Route path="/services/ai-strategy" element={<AIStrategy />} />
                <Route path="/services/erp-sap-advisory" element={<ERPStrategy />} />
                <Route path="/services/technology-strategy" element={<TechnologyStrategy />} />
                <Route path="/services/:slug" element={<ServicePage />} />
                <Route path="/industries" element={<Industries />} />
                <Route path="/case-studies" element={<CaseStudies />} />
                <Route path="/insights" element={<Insights />} />
                <Route path="/insights/:slug" element={<InsightDetail />} />
                <Route path="/videos" element={<Videos />} />
                <Route path="/resources" element={<Resources />} />
                <Route path="/book" element={<BookSession />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy" element={<Legal variant="privacy" />} />
                <Route path="/terms" element={<Legal variant="terms" />} />
                <Route path="/journal" element={<Journal />} />
                <Route path="/journal/:slug" element={<JournalDetail />} />
                <Route path="/success-stories" element={<SuccessStories />} />
                <Route path="/success-stories/:slug" element={<SuccessStoryDetail />} />
                <Route path="*" element={<NotFound />} />
              </Route>
              <Route path="/admin" element={<Navigate to="/404-unavailable" replace />} />
              <Route path="/admin/*" element={<Navigate to="/404-unavailable" replace />} />
              <Route path="/adminia/login" element={<AdminLogin />} />
              <Route element={<AdminProtected />}>
                <Route element={<AdminLayout />}>
                  <Route path="/adminia" element={<AdminDashboard />} />
                  <Route path="/adminia/blogs/new" element={<AdminBlogEditor />} />
                  <Route path="/adminia/blogs/:id/edit" element={<AdminBlogEditor />} />
                  <Route path="/adminia/media" element={<AdminMedia />} />
                  <Route path="/adminia/security" element={<AdminSecurity />} />
                </Route>
              </Route>
            </Routes>
          </SmoothScroll>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
